import { defineMessages } from "react-intl";

const messages = defineMessages({
  errorModal: {
    id: "fileStorage.components.errorModal.errorModal",
    defaultMessage: `An error occurred with loading this application. Please try again.`,
  },
});

export default messages;
